// extracted by mini-css-extract-plugin
export default {"largeCheckbox":"Matches_largeCheckbox__35hcV"};